export default "__VITE_ASSET__C_08DnfG__"